import { AVFreezeEvent } from './types';
import intermind from '../../index';

export class TelemetryResource {
  private queue: AVFreezeEvent[] = [];
  private flushScheduled = false;

  sendFreezeEvents(events: AVFreezeEvent[]) {
    console.debug(
      `[Telemetry] Queuing ${events.length} freeze events. Events: ${events.map((e) => `${e.participantId} ${e.kind} ${e.frozen}`).join(', ')}`
    );

    this.queue.push(...events);
    if (!this.flushScheduled) {
      this.flushScheduled = true;
      setTimeout(() => this.flushQueue(1), 3000);
    }
  }

  private async flushQueue(attempt: number) {
    while (this.queue.length > 0) {
      const batch = this.queue.slice(0, 10);

      console.debug(`[Telemetry] Sending batch of ${batch.length} (attempt ${attempt})`);

      try {
        const res = await intermind.httpClient.post('/telemetry/freeze-events', batch, {
          headers: { 'Content-Type': 'application/json' },
        });

        if (res.status >= 200 && res.status < 300) {
          console.debug('[Telemetry] Batch sent successfully');
          this.queue.splice(0, batch.length);
        } else {
          throw new Error(`Unexpected status: ${res.status}`);
        }
      } catch (e) {
        console.warn(`[Telemetry] Failed to send batch (attempt ${attempt})`, e);

        if (attempt < 3) {
          const nextDelay = attempt * 3000; // 3s, 6s
          this.flushScheduled = true;
          setTimeout(() => this.flushQueue(attempt + 1), nextDelay);
          return;
        }

        console.warn('[Telemetry] Giving up after 3 attempts, will retry later');
        this.flushScheduled = false;
      }
    }

    console.debug('[Telemetry] All events sent, queue is now empty');
    this.flushScheduled = false;
  }
}
